export { default } from "@casino/client/utils/storage/LocalStorage";
